import { ChangeDetectionStrategy, Component, input, model } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { S25IconButtonComponent } from "../s25.icon.button.component";

@Component({
    selector: "s25-waitlist-position-editor",
    template: `
        <input
            type="number"
            [min]="1 + offset()"
            [max]="(maxPosition() ?? 0) + offset()"
            class="c-input noArrows"
            [ngModel]="(position() ?? 0) + offset()"
            (ngModelChange)="clampAndSet($event)"
            [attr.aria-label]="'Position'"
        />
        @if (maxPosition() > 1) {
            <s25-ng-icon-button
                [type]="'arrowUp'"
                [ariaLabel]="'Move up'"
                (clicked)="clampAndSet((position() ?? 0) + offset() - 1)"
            />
            <s25-ng-icon-button
                [type]="'arrowDown'"
                [ariaLabel]="'Move down'"
                (clicked)="clampAndSet((position() ?? 0) + offset() + 1)"
            />
        }
    `,
    host: { style: "display: inline-flex; align-items: center; gap: 2px; color: var(--s25-link-color, #2573a7)" },
    standalone: true,
    imports: [FormsModule, S25IconButtonComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WaitlistPositionEditorComponent {
    readonly position = model<number>();
    readonly maxPosition = input<number>();
    /** Shifts displayed values without affecting internal position. */
    readonly offset = input<number>(0);

    clampAndSet(displayValue: number) {
        const internal = displayValue - this.offset();
        this.position.set(Math.max(1, Math.min(internal, this.maxPosition() ?? internal)));
    }
}
